import React from "react";
import { Box, Stack } from "@mui/material";
import { DtHeader } from "./DtHeader";

interface PageHeaderProps {
  children: React.ReactNode;
  sx?: object;
  divider?: boolean;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

const DtPageHeader: React.FC<PageHeaderProps> = ({
  children,
  sx,
  divider = true,
  icon,
  actions,
}) => {
  return (
    <Box sx={{ ...sx }}>
      <DtHeader
        level="h5"
        sx={{ m: 0 }}
        icon={icon}
        divider={divider}
        actions={actions}
      >
        {children}
      </DtHeader>
    </Box>
  );
};

export { DtPageHeader };